/**
 * Adiciona a classe CSS 'no_padding' ao elemento 'body' do documento.
 *
 * @function
 * @name removeBodyCss
 * @returns {void}
 */
function removeBodyCss() {
  document.body.classList.add("no_padding");
}

/**
 * Verifica se o dispositivo atual é um dispositivo móvel.
 *
 * @function
 * @name isMobile
 * @returns {boolean} Retorna verdadeiro se o dispositivo for móvel, falso caso contrário.
 */
function isMobile() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

/**
 * Copia o conteúdo fornecido para a área de transferência.
 *
 * @param {string} content O conteúdo a ser copiado para a área de transferência.
 * @returns {void}
 */
function copiarConteudo(content) {
  return new Promise((resolve) => {
    const tempElement = document.createElement("textarea");
    tempElement.value = content;

    document.body.appendChild(tempElement);
    tempElement.select();
    document.execCommand("copy");
    document.body.removeChild(tempElement);
    resolve();
  });
}

const CommonsHelper = { removeBodyCss, copiarConteudo, isMobile };
export default CommonsHelper;
